import { Component, ElementRef, HostListener, OnDestroy, ViewEncapsulation } from "@angular/core";
import { RootScope } from "../../commons/services/rootScope.service";
import { OpPrimarySidebarService } from "../opPrimarySidebar/opPrimarySidebar.service";

@Component({
  selector: "button[opPrimarySidebarToggle]",
  templateUrl: "./opPrimarySidebarToggle.view.html",
  styleUrls: ['./opPrimarySidebarToggle.style.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true
})
export class OpPrimarySidebarToggle implements OnDestroy {

  private _activeSubscription = this._sidebar.activeChange.subscribe(v => this._activeChanged(v));

  constructor(
    private _host: ElementRef<HTMLButtonElement>,
    private $rootScope: RootScope,
    private _sidebar: OpPrimarySidebarService
  ) {
    this._host.nativeElement.classList.add('op-primary-sidebar-toggle');
  }

  @HostListener('click', ['$event'])
  toggleSidebar($event: MouseEvent) {
    $event.preventDefault();
    this._sidebar.toggle();
    if (this.$rootScope.largeScreen) setTimeout(() => this._dispatchRezise(), 290);
  }

  private _dispatchRezise() {
    window.dispatchEvent(new Event('resize'));
  }

  private _activeChanged(value: boolean): void {
    if (value) this._host.nativeElement.classList.add('active');
    else this._host.nativeElement.classList.remove('active');
  }

  ngOnDestroy(): void {
    this._activeSubscription.unsubscribe();
  }
}
